import { missingTranslationLocales } from "src/utils/localeTranslations";
import { BusinessDataTranslation } from "src/interfaces/menu.interface";

type TranslationCompletenessBadgeProps = {
  translations?: BusinessDataTranslation[];
  enabledLocales: string[];
};

const TranslationCompletenessBadge = ({
  translations,
  enabledLocales,
}: TranslationCompletenessBadgeProps) => {
  const missing = missingTranslationLocales(translations, enabledLocales);
  if (missing.length === 0 || enabledLocales.length <= 1) {
    return null;
  }

  return (
    <span
      className="inline-flex items-center rounded-md border border-amber-200 bg-amber-50 px-2 py-0.5 text-xs text-amber-800"
      title={`Missing names for: ${missing.join(", ")}`}
    >
      Needs translation
    </span>
  );
};

export default TranslationCompletenessBadge;
